export default __webpack_public_path__ + "static/media/innovation_cup.3fe2e347.jpg";